/**
 * Recursively find a parent vm of certain type. Useful for finding the root form instance or
 * the rf-section a rf-section-nav belongs to.
 * @param   {Vue}  vm
 * @param   {String}  type
 * @return  {Vue}
 */
export default function getParent (vm, type) {
  if (vm.componentType === type) {
    return vm
  } else if (typeof vm.$parent !== 'undefined') {
    return getParent(vm.$parent, type)
  }
}



// WEBPACK FOOTER //
// ./src/frontend/util/getParent.js